<template>
	<div>
		<el-select
			v-model="id"
			size="mini"
			filterable
			remote
			default-first-option
			allow-create
			:clearable="true"
			placeholder="上市时间搜索"
			@change="handleChange"
			:remote-method="refreshData"
			:loading="loadings.main"
		>
			<el-option v-for="item in options" :key="item._id" :label="item.name" :value="item._id"></el-option>
		</el-select>
	</div>
</template>
<script>
import RelateInput from "@/mixins/RelateInput.js";

export default {
	mixins: [RelateInput],
	data() {
		return {
			dataModel: "Season"
		};
	}
};
</script>
